import { useEffect, useState } from 'react';

import { useAppState } from '../../AppStateProvider';
import { appStore } from '../../services/appStore';
import { setSettingsItems } from '../../services/windowMessaging/windowMessaging';

import { useSettingsTracking } from './useSettingsTracking';

const TIMEOUT = 1000;

export const useSettingEnabling = () => {
  const { settingsStorage } = useAppState();
  const [isSettingApplied, setIsSettingApplied] = useState(false);
  const { handleTrackSettingsChange } = useSettingsTracking();

  const shouldEnableSettingFor = settingsStorage?.shouldEnableToggle;

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;
    let tooltipTimeoutId: NodeJS.Timeout;

    if (shouldEnableSettingFor) {
      timeoutId = setTimeout(() => {
        appStore.setSettingsStorageValue({ [shouldEnableSettingFor]: true });
        handleTrackSettingsChange(shouldEnableSettingFor, true);
        window.parent.postMessage({ message: 'show icon' }, '*');
        setSettingsItems({ [shouldEnableSettingFor]: true });

        tooltipTimeoutId = setTimeout(() => {
          appStore.setSettingsStorageValue({ shouldEnableToggle: undefined });
          setIsSettingApplied(true);
        }, TIMEOUT);
      }, TIMEOUT);
    }

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(tooltipTimeoutId);
    };
  }, [shouldEnableSettingFor]);

  return { isSettingApplied };
};
